'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log to console since logger might not be available in global error
    console.error('[GLOBAL ERROR]', {
      message: error.message,
      stack: error.stack,
      digest: error.digest,
    })
  }, [error])

  return (
    <html>
      <body>
        <div
          style={{
            display: 'flex',
            minHeight: '100vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <h2
              style={{
                marginBottom: '1rem',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#111827',
              }}
            >
              Kritická chyba aplikace
            </h2>
            <p
              style={{
                marginBottom: '1.5rem',
                color: '#4B5563',
              }}
            >
              Omlouváme se, ale nastala závažná chyba. Prosím, obnovte stránku.
            </p>
            <button
              onClick={() => reset()}
              style={{
                borderRadius: '0.375rem',
                backgroundColor: '#16a34a',
                padding: '0.5rem 1rem',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Zkusit znovu
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
